module.exports = __webpack_public_path__ + "img/Dual Ring-1s-200px (1).2780fb90.svg";